import React, { useState } from "react";
import Button from "ui-components/button";
import eye from "../../assets/images/eye_icon.png"
import eyeClosed from "../../assets/images/disable_eye_icon.png"
import LoginButtonGroup from "components/shared/login-button-group";


let passwordResetUrl = "https://apocampus.herokuapp.com/password_resets/new";
let baseUrl = window.location.origin;
if (baseUrl.includes("localhost") || baseUrl.includes("apocampus-staging")) {
  passwordResetUrl =
    "https://apocampus-staging.herokuapp.com/password_resets/new";
}

const LoginBox = ({ setEmail, setPassword, authenticate }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
    <LoginButtonGroup />
    <form className='login-box'>
      <input
        label="E-Mail"
        name="email"
        placeholder="E-mail"
        className="login-box-input"
        onChange={(e) => {
          setEmail(e.target.value);
        }}
      />
      <div className="password-wrapper">
        <input
          label="Passwort"
          name="password"
          type={showPassword ? "text" : "password"} 
          placeholder="Passwort"
          className="login-box-input"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <span
          className="toggle-password-icon"
          onClick={togglePasswordVisibility}
        >
          <img 
            src={showPassword ?  eye : eyeClosed} 
            style={{ filter: 'invert(33%) sepia(97%) saturate(599%) hue-rotate(165deg) brightness(91%) contrast(92%)' }}
          />
        </span>
      </div>
      <div
        className="login-box-bottom"
      >
        <a 
          href={passwordResetUrl}
          className="login-box-link"
        >
          Passwort vergessen?
        </a>
      </div>
      <Button
        onClick={authenticate}
        className='login-box-button'
      >
        EINLOGGEN
      </Button>
    </form>
    </>
  );
};

export default LoginBox;
